<h2>upp-visible-control</h2>
<p class="demo-description">Lazy image gallery — content renders only when <code>upp-visible-control</code> detects the item is in the viewport.</p>

<div class="demo-controls">
    <ion-badge color="primary" class="counter-badge">
        {{ visibleCount }} of {{ images.length }} images in viewport
    </ion-badge>
    <span class="hint">Scroll down to load more</span>
</div>

<div class="demo-section">
    <div class="gallery-scroll">
        <div *ngFor="let img of images; let i = index" class="gallery-slot">
            <upp-visible-control mode="content" (visibilityChange)="onVisibilityChange(i, $event)">
                <div class="image-card" *ngIf="visibilityMap[i]; else placeholder">
                    <div class="image-preview" [style.background]="img.color">
                        <ion-icon [name]="img.icon" class="image-icon"></ion-icon>
                    </div>
                    <div class="image-info">
                        <span class="image-title">{{ img.title }}</span>
                        <span class="image-desc">{{ img.description }}</span>
                    </div>
                </div>
                <ng-template #placeholder>
                    <div class="image-card image-card--placeholder">
                        <div class="image-preview image-preview--placeholder">
                            <ion-icon name="image-outline" class="image-icon image-icon--placeholder"></ion-icon>
                        </div>
                        <div class="image-info">
                            <span class="placeholder-bar placeholder-bar--title"></span>
                            <span class="placeholder-bar placeholder-bar--desc"></span>
                        </div>
                    </div>
                </ng-template>
            </upp-visible-control>
        </div>
    </div>
</div>
